import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { AnalyticsService } from 'src/app/@services/analytics.service';

export function appRouteTrackingInitializer() {
  return (): void => {
    const router = inject(Router);
    const analyticsService = inject(AnalyticsService);
    const destroyRef = inject(DestroyRef);

    router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap((event: NavigationEnd) => {
          analyticsService.trackPageView(
            event.urlAfterRedirects,
            document.title
          );
        }),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe();
  };
}
